export default __webpack_public_path__ + "static/media/38.e3795701.jpg";